import React from 'react'
import AddDeliveryContainer from '../../../../../Components/UserPart/AddUser/AddDeliveryContainer/AddDeliveryContainer'
import Layout from '../../../Layout'

const AddDelivery = () => {
  return (
    <Layout>
        <AddDeliveryContainer/>
    </Layout>
  )
}

export default AddDelivery